import { useRef } from "react";

function InputIban(props) {

  const inputRef = useRef();

  const checkPattern = () => {
    const re = new RegExp(props.pattern);
    return !props.value || !props.pattern || re.test(props.value.toUpperCase());
  }

  const checkOtherField = () => {
    const check = !props.value || !props.otherField || props.value.startsWith(props.otherFields.get(props.otherField));
    check ? inputRef.current?.setCustomValidity('') : inputRef.current?.setCustomValidity('Il codice meccanografico non è conforme alla provincia selezionata');
    return check;
  }

  return (
    <div className={'rtds-input-field rtds-gap-1 ' + (props.classDiv ?? '')} hidden={props.hidden}>
      <label htmlFor={props.id} className={'rtds-input-field__label ' + props.classLabel}>
        {props.label}{props.required ? ' ' : ''}
        <abbr
          hidden={!props.required}
          className='rtds-font-bold rtds-no-underline'
          title='obbligatorio'
        >
          *
        </abbr>
      </label>

      <div
        className={
          (props.classDivInput ?? 'rtds-input ') +
          (props.inputErrors?.includes(props.id) ? ' has-error' : '')
        }
      >
        <span
          hidden={!props.addon}
          className='rtds-px-3 rtds-content-center rtds-content-03 rtds-whitespace-nowrap'
          style={{ height: 'var(--spacing-11)' }}
        >
          {props.labelSpan ?? '+39'}
        </span>
        <input
          ref={inputRef}
          required={!!props.required}
          id={props.id}
          name={props.id}
          className={
            props.classInput +
            (props.disabled || props.readOnly ? ' rtds-background-02' : '')
          }
          type={props.type}
          aria-describedby={props.id + 'Error'}
          placeholder={props.placeholder}
          onKeyDown={(event) => props.onKeyPress ? props.onKeyPress(event) : null}
          onChange={(event) => props.onChange(event)}
          aria-invalid={props.inputErrors?.includes(props.id) || (props.inputErrors && !checkOtherField())}
          value={props.value}
          minLength={props.minLength}
          maxLength={props.maxLength}
          disabled={props.disabled}
          pattern={props.pattern}
          hidden={props.hidden}
          title={props.title}
          readOnly={props.readOnly}
        />
        {props.elementExtender}
        {/* {props.inputErrors?.includes(props.id) && (
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
        )} */}
        {props.errorIban && (
          <svg
            className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error'
            aria-hidden='true'
            focusable='false'
            role='img'
          >
            <use
              xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
            />
          </svg>
        )}
        {
          props.loading && (
            <svg
              className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-8 rtds-animate-spin rtds-background-01'
              aria-hidden='true'
              focusable='false'
              role='img'
            >
              <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
            </svg>
          )
        }
      </div>

      <span
        className='rtds-input-field__hint'
        hidden={!props.inputErrors?.includes(props.id)}
      >
        <span
          className='rtds-input-field__error'
          id={props.id + 'Error'}
          aria-live='assertive'
        >
          {
            !checkPattern()
              ? props.errorPattern ?? 'Formato campo non valido'
              : !checkOtherField()
                  ? props.errorOtherField ?? 'Valore non conforme'
                  : props.errorMessage ?? 'Campo obbligatorio'
          }
        </span>
      </span>

      
              <span className='rtds-input-field__hint'>
                <span
                  className='rtds-input-field__description'
                  id={`${props.id}idSelectDescription`}
                >
                  L’IBAN indicato deve essere italiano, deve iniziare con “IT” seguito da 25 caratteri <br/><span className="rtds-content-info">(esempio: IT60X0542811101000000123456)</span>
                </span>
              </span>
            
    </div>
  );
}

export default InputIban;
